export function renderHome() {
  return `
    <div class="wrap">
      <div class="panel">
        <h1>Incidencias huésped</h1>
        <p class="muted">Cuéntanos tu problema y te ayudamos.</p>
        <form id="create-form">
          <label for="site_code">Código de hotel / sede</label>
          <input id="site_code" name="site_code" required maxlength="64" autocomplete="off" placeholder="" />
          <p class="muted small">El código te lo indica el hotel (recepción o cartel en la habitación).</p>
          <label for="requester_name">Nombre (opcional)</label>
          <input id="requester_name" name="requester_name" maxlength="255" autocomplete="name" />
          <label for="requester_email">Email</label>
          <input id="requester_email" name="requester_email" type="email" required maxlength="255" autocomplete="email" />
          <label for="phone">Teléfono (opcional)</label>
          <input id="phone" name="phone" type="tel" maxlength="64" autocomplete="tel" />
          <label for="subject">Asunto</label>
          <input id="subject" name="subject" required maxlength="255" />
          <label for="room">Habitación (opcional)</label>
          <input id="room" name="room" maxlength="64" />
          <label for="description">Mensaje</label>
          <textarea id="description" name="description" required maxlength="10000"></textarea>
          <div class="btn-row">
            <button class="btn" type="submit">Enviar incidencia</button>
            <a class="btn btn--ghost" data-link href="/consultar">Consultar mi ticket</a>
          </div>
        </form>
        <p id="create-msg" class="msg" role="status"></p>
      </div>
    </div>
  `
}

export function bindHome({ navigate }) {
  const form = document.getElementById('create-form')
  const msg = document.getElementById('create-msg')
  form?.addEventListener('submit', async (ev) => {
    ev.preventDefault()
    msg.textContent = 'Enviando…'
    msg.className = 'msg'
    const fd = new FormData(form)
    try {
      const { createGuestTicket } = await import('../api.js')
      const data = await createGuestTicket({
        requester_name: fd.get('requester_name') || '',
        requester_email: fd.get('requester_email'),
        phone: fd.get('phone') || '',
        subject: fd.get('subject'),
        description: fd.get('description'),
        room: fd.get('room') || '',
        site_code: fd.get('site_code') || '',
      })
      msg.textContent = data.message || 'Ticket registrado.'
      msg.className = 'msg msg--ok'
      const token = data.ticket?.access_token
      if (token) {
        setTimeout(() => navigate(`/t/${token}`), 600)
      }
    } catch (e) {
      msg.textContent = e.message || 'No se pudo enviar.'
      msg.className = 'msg msg--err'
    }
  })
}
